import axios from "axios";
export const api = axios.create();
export const baseUrl = process.env.REACT_APP_API_URL || "/api/v1" ;
export const socketUrl = process.env.REACT_APP_SOCKET_API_URL || "/api/v1";
